import styled from "styled-components";
import {DivPlaceholder, TextPlaceholder, usePlaceholderLoading} from "../../components/Loading/placeholder";

export const Title = styled(TextPlaceholder).attrs({
    lines: [1],
    itemStyle: {
        height: 20,
        margin: "24px 0 12px 0",
        width: 200
    }
})`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #494949;
  margin-bottom: 12px;
  margin-top: 24px;
`

export const BookingInfoTitle = styled(DivPlaceholder).attrs({
    style: {
        height: 16,
        margin: 0,
        marginRight: 6,
        minWidth: 50,
        borderRadius: 6,
        display: "flex",
        alignItems: "center"
    }
})`
`

export const BookingInfoValue = styled(BookingInfoTitle).attrs({
    style: {
        height: 16,
        margin: 0,
        minWidth: 150,
        borderRadius: 6,
        display: "flex",
        alignItems: "center"
    }
})``

export const Booking = styled.div`
  padding: 12px;
  background: linear-gradient(0deg, #F7F7F7, #F7F7F7), #F7F9FA;
  border: 1px solid #DDDDDD;
  backdrop-filter: blur(2px);
  border-radius: 8px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li:last-child {
      margin-bottom: 0;
    }

    li {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 4px;

      svg {
        width: 12px;
        height: 12px;
        margin-right: 6px;
        flex: none;
      }

      b {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: #22313F;
      }

      span {
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        color: #727C8A;
        margin-left: 3px;
      }
    }
  }
`;
export const Service = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  background: linear-gradient(0deg, #F7F7F7, #F7F7F7), rgba(255, 255, 255, 0.7);
  border: 1px solid #DDDDDD;
  border-radius: 8px;
  overflow: hidden;

  .image {
    width: 96px;
    height: 96px;
    overflow: hidden;
    margin-right: 16px;

    & img {
      width: 96px;
      height: 96px;
      object-fit: cover;
    }
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    h3 {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #101820;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    div.info-value {
      margin: 0;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      color: #727C8A;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /* number of lines to show */
      line-clamp: 3;
      -webkit-box-orient: vertical;

      p, h1, h2, h3, h4, h5, ul {
        margin-bottom: 3px;
        margin-block: 0;
      }
    }
  }
`;

export const Question = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 8px;
  margin-bottom: 16px;

  .index {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    background: ${props => props.theme.main || "#40A68C"};;
    border-radius: 50px;
    margin-right: 12px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    flex: none;
  }

  .content {
    flex: 1;
    max-width: calc(100% - 32px);
    word-break: break-word;
    h3 {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #494949;
      margin-bottom: 6px;
    }

    ul {
      padding: 0;
      margin: 0;
      padding-left: 16px;
    }

    p, li {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #727C8A;
      white-space: pre-wrap;
    }
  }
`
export const Questionnaire = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
`;
export const QuestionnaireImages = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-top: 6px;
`;
export const QuestionnaireImage = styled.div`
  margin-right: 4px;
  position: relative;

  img {
    border-radius: 8px;
    width: 87px;
    height: 52px;
    object-fit: cover;
    border: 1px solid #f5f5f5;
  }

  .open {
    position: absolute;
    display: none;
  }

  &:hover:after {
    width: 100%;
    height: 100%;
    position: absolute;
    content: "";
    z-index: 1;
    background-color: #ffffffc2;
    top: 0;
    left: 0;
    border-radius: 8px;
    border: 1px solid lightgray;
  }

  &:hover .open {
    display: block;
    top: 14px;
    left: 33px;
    z-index: 2;
    cursor: pointer;
  }
`;
export const ImagePdf = styled.div`
  border-radius: 8px;
  width: 87px;
  height: 52px;
  background: #EAEEF9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 9px;

  & > svg {
    position: inherit !important;
    width: 25px;
    height: auto;
  }

  .filename {
    font-weight: 400;
    font-size: 10px;
    line-height: 18px;
    color: #1B1B1B;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75px;
    margin-top: 3px;

    span {
      white-space: nowrap;
    }

    & > span:first-child {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;

export const ViewImageModal = styled.div`
  position: fixed;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  top: 0;
  left: 0;
  background: rgba(27, 27, 27, 0.5);
  display: flex;
  flex-direction: column;
  z-index: 3;
  transition: all 0.3s;
`;
export const ViewImageModalImage = styled.div`
  background: #494949;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  height: 70%;
  width: calc(100% - 32px);
  margin: 0 16px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-direction: column;
  display: flex;
  margin-bottom: 20px;

  img {
    overflow: hidden;
    width: 100%;
    height: auto;
    object-fit: cover;
  }
`;
export const ViewImageModalClose = styled.div`
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-direction: column;
  display: flex;
  cursor: pointer;
`;


export const AddOn = styled.div`
  border-radius: 8px;
  border: 1px solid var(--black-black-200, #DDD);
  background: linear-gradient(0deg, #F6F6F6 0%, #F6F6F6 100%), rgba(255, 255, 255, 0.70);
  backdrop-filter: blur(2px);
  padding: 8px 16px;
  margin-top: 12px;
`;
export const AddOnTitle = styled.div`
  color: var(--ink-ink-600, #101820);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 4px;
`;
export const AddOnItems = styled.div``;
export const AddOnItem = styled.div`
  color: var(--ink-ink-400, #727C8A);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  position: relative;
  padding-left: 15px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  &:before {
    content: "";
    position: absolute;
    width: 3px;
    height: 3px;
    border-radius: 3px;
    background-color: #727C8A;
    top: 8px;
    left: 4px;
  }
`;


export const CloseModalIcon = (props) => {
    return (
        <svg {...props} width="40" height="40" viewBox="0 0 40 40" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.0002 3.33325C10.8168 3.33325 3.3335 10.8166 3.3335 19.9999C3.3335 29.1833 10.8168 36.6666 20.0002 36.6666C29.1835 36.6666 36.6668 29.1833 36.6668 19.9999C36.6668 10.8166 29.1835 3.33325 20.0002 3.33325ZM25.6002 23.8333C26.0835 24.3166 26.0835 25.1166 25.6002 25.5999C25.3502 25.8499 25.0335 25.9666 24.7168 25.9666C24.4002 25.9666 24.0835 25.8499 23.8335 25.5999L20.0002 21.7666L16.1668 25.5999C15.9168 25.8499 15.6002 25.9666 15.2835 25.9666C14.9668 25.9666 14.6502 25.8499 14.4002 25.5999C13.9168 25.1166 13.9168 24.3166 14.4002 23.8333L18.2335 19.9999L14.4002 16.1666C13.9168 15.6833 13.9168 14.8833 14.4002 14.3999C14.8835 13.9166 15.6835 13.9166 16.1668 14.3999L20.0002 18.2333L23.8335 14.3999C24.3168 13.9166 25.1168 13.9166 25.6002 14.3999C26.0835 14.8833 26.0835 15.6833 25.6002 16.1666L21.7668 19.9999L25.6002 23.8333Z"
                fill="white"/>
        </svg>
    )
}
export const PdfIcon = (props) => (
    <svg {...props} width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M14.3498 0H33.0725L48.9405 16.5397V48.7097C48.9405 52.7396 45.6802 56 41.6641 56H14.3498C10.3199 56 7.05951 52.7396 7.05951 48.7097V7.29033C7.05944 3.26036 10.3198 0 14.3498 0Z"
              fill="#727C8A"/>
        <path opacity="0.302" fillRule="evenodd" clipRule="evenodd" d="M33.0585 0V16.4138H48.9405L33.0585 0Z"
              fill="white"/>
        <path
            d="M15.1614 41.7831V31.5542H19.5132C20.5907 31.5542 21.4443 31.848 22.088 32.4498C22.7316 33.0375 23.0535 33.8351 23.0535 34.8286C23.0535 35.822 22.7316 36.6197 22.088 37.2074C21.4443 37.8091 20.5907 38.1029 19.5132 38.1029H17.7781V41.7831H15.1614ZM17.7781 35.8781H19.2194C19.6112 35.8781 19.919 35.7941 20.129 35.5982C20.3388 35.4163 20.4508 35.1644 20.4508 34.8286C20.4508 34.4928 20.3389 34.2409 20.129 34.059C19.9191 33.8631 19.6112 33.7792 19.2194 33.7792H17.7781V35.8781ZM24.1309 41.7831V31.5542H27.7551C28.4687 31.5542 29.1404 31.6521 29.7701 31.8621C30.3997 32.0719 30.9735 32.3658 31.4772 32.7716C31.981 33.1634 32.3868 33.6951 32.6806 34.3668C32.9605 35.0385 33.1144 35.8081 33.1144 36.6756C33.1144 37.5292 32.9605 38.2989 32.6806 38.9705C32.3868 39.6422 31.981 40.1739 31.4772 40.5657C30.9734 40.9714 30.3997 41.2653 29.7701 41.4752C29.1404 41.6851 28.4687 41.7831 27.7551 41.7831H24.1309ZM26.6916 39.5582H27.4472C27.853 39.5582 28.2309 39.5163 28.5807 39.4183C28.9165 39.3204 29.2384 39.1664 29.5462 38.9565C29.8401 38.7467 30.0779 38.4528 30.2458 38.061C30.4137 37.6692 30.4977 37.2074 30.4977 36.6756C30.4977 36.1299 30.4137 35.6682 30.2458 35.2764C30.0779 34.8846 29.8401 34.5908 29.5462 34.3808C29.2384 34.171 28.9166 34.017 28.5807 33.9191C28.2309 33.8211 27.853 33.7791 27.4472 33.7791H26.6916V39.5582ZM34.4298 41.7831V31.5542H41.7062V33.7791H37.0465V35.4163H40.7686V37.6272H37.0465V41.7831H34.4298Z"
            fill="white"/>
    </svg>
)

export const EyeIcon = (props) => (
    <svg {...props} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M21.263 14.9185C18.9478 18.5452 15.5649 20.6304 12.0049 20.6253C10.2249 20.6228 8.49562 20.1003 6.917 19.1281C5.3384 18.1458 3.92043 16.7138 2.76303 14.8922C1.76526 13.3207 1.76889 10.7707 2.77113 9.20216C5.08631 5.56546 8.46927 3.49027 12.0293 3.49534C13.8093 3.49788 15.5385 4.02034 17.1171 4.99259C18.6957 5.97484 20.1137 7.40686 21.2711 9.22851C22.2689 10.7899 22.2652 13.3499 21.263 14.9185ZM12.0228 8.01534C9.78283 8.01215 7.98026 9.81958 7.97708 12.0496C7.9739 14.2796 9.77133 16.0921 12.0113 16.0953C14.2513 16.0985 16.0539 14.2911 16.0571 12.0611C16.0602 9.83109 14.2628 8.01853 12.0228 8.01534Z"
            fill="#989898"/>
        <path
            d="M12.0131 14.9154C10.4431 14.9132 9.16491 13.6314 9.16716 12.0514C9.16939 10.4814 10.4512 9.20321 12.0212 9.20544C13.5912 9.20768 14.8794 10.4895 14.8772 12.0595C14.8749 13.6295 13.5831 14.9177 12.0131 14.9154Z"
            fill="#989898"/>
    </svg>

)

export const QuestionPlaceholderLoading = (props) => {
    const {loading} = usePlaceholderLoading();
    if (!loading) {
        return null;
    }
    return (
        <div style={{marginTop: 12, marginBottom: 24}}>
            <div style={{display: "flex", alignItems: "center"}}>
                <DivPlaceholder lines={[1]} style={{width: 20, height: 20, borderRadius: 10, marginLeft: 0}}/>
                <div style={{flex: 1, paddingLeft: 6}}><TextPlaceholder lines={[1]} itemStyle={{
                    height: 20,
                    borderRadius: 10,
                    margin: 0
                }}/></div>
            </div>
            <TextPlaceholder lines={[1]} itemStyle={{height: 24, borderRadius: 8}}/>
        </div>
    )
}